import { SamlNameIdFormat } from "types/generated";
import { ClaimMappingFormValue, EMPTY_CLAIM_MAPPING_VALUE } from "components/FormFields/ClaimMapping";

export type SettingsSingleSignOnSAMLFormFields = {
  nameIDFormat: SamlNameIdFormat;
  dynamic: boolean;
  metadata: string;
  claimMapping: ClaimMappingFormValue[];
};

export const formDefaultValues: SettingsSingleSignOnSAMLFormFields = {
  nameIDFormat: SamlNameIdFormat.Transient,
  dynamic: false,
  metadata: "",
  claimMapping: [EMPTY_CLAIM_MAPPING_VALUE],
};
